import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Routing from "./routes/Routing";
import {ConfirmContextProvider} from "../src/contextprovider/confirmcontextprovider";
import { PermissionProvider } from './context/permissionContext';


import 'bootstrap/dist/css/bootstrap.min.css';

// Release-pipeline smoke check — temporary, safe to remove.
console.log('[intelog] release pipeline check — build OK');

ReactDOM.render(
    <React.StrictMode>
        <PermissionProvider>
            <ConfirmContextProvider>
            <Routing />
            </ConfirmContextProvider>
            </PermissionProvider>
    </React.StrictMode>,
    document.getElementById("root")
);